/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import {RoomApi } from '../api/room.api';
import { switchMap, map } from 'rxjs/operators';
import { RoomData, Room } from '../../../interfaces/masters/room';

@Injectable()
export class RoomService extends RoomData {

  constructor(private api: RoomApi) {
    super();
  }


  list(url: string): Observable<Room[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Room>{
      return this.api.getById(url);
  }

  create(url: string, data:Room): Observable<Room[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:Room): Observable<Room> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
